module.exports = __webpack_public_path__ + "static/media/suggestion.6ba53c3b.svg";